import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const Products = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Products</h1>
                <p className="colorWht">GreenOrange Products</p>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                <h2>
                  <span className="heading-bg"></span>Our Products<span className="heading-bg"></span>
                </h2>
                <p className="color4">GreenOrange a one stop for all your Solutions</p>
              </div>
            </div>
            <div className="row products text-center">
              <div className="col-lg-4 col-md-4 col-sm-4 padLR15">
                <article>
                  <Link to="/transport-management-system" title="Transport Management System - TMS">
                    <div className="services-icons">
                      <span>
                        <i className="fa fa-map-marker"></i>
                      </span>
                    </div>
                    <div className="clearfix"></div>
                    <h3>TMS</h3>
                    <p>
                      Whether you operate your own private fleet or procure outside carrier services,
                      our Transportation Management software offers the scope...
                    </p>
                  </Link>
                  <p>
                    <Link className="btn btn-default morebtn" to="/transport-management-system" role="button">
                      See More
                    </Link>
                  </p>
                </article>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 padLR15">
                <article>
                  <Link to="/payroll" title="Payroll">
                    <div className="services-icons">
                      <span>
                        <i className="fa fa-map-marker"></i>
                      </span>
                    </div>
                    <div className="clearfix"></div>
                    <h3>Payroll</h3>
                    <p>
                      An integrated Payroll within your TMS Software will save you enourmous number
                      of hours required to generate payslips for your employees...
                    </p>
                  </Link>
                  <p>
                    <Link className="btn btn-default morebtn" to="/payroll" role="button">
                      See More
                    </Link>
                  </p>
                </article>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 padLR15">
                <article>
                  <Link to="/gps-tracking-software" title="GPS as Software">
                    <div className="services-icons">
                      <span>
                        <i className="fa fa-map-marker"></i>
                      </span>
                    </div>
                    <div className="clearfix"></div>
                    <h3>GPS</h3>
                    <p>
                      Not long ago it seemed that everything is already discovered in GSM network,
                      but HSCSD, GPRS, EDGE bearers created new possibilities for...
                    </p>
                  </Link>
                  <p>
                    <Link className="btn btn-default morebtn" to="/gps-tracking-software" role="button">
                      See More
                    </Link>
                  </p>
                </article>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default Products;

